import React from 'react'
import { LAYOUT } from '../../pages/data';
import TitleDescription from '../common/titleDescription';

const SectionLayout = ({
    logo,
    title,
    description,
    children,
    layout = LAYOUT.center,
    playstoreBtns,
    className = "",
    id = "",
    styles,
    isHide=false,
    isLoading
  }) => {
    const isCenterAligned = layout === LAYOUT.center;
    const isLeftAligned = layout === LAYOUT.left;
    const isRightAligned = layout === LAYOUT.right;
  
    return (
      <div
        style={styles}
        className={`max767:px-5 max767:py-16 ipad:px-12 pb-[120px] ipad:py-16 section ${className} ${id} 
        ${( id === "section8" || id === "section2") ? " pt-[0px] max767:pt-0" : " pt-[120px]"} 
       
        
        ${id === "section1" ? "pb-[0px]" : "pb-[120px]"} 
       ${isHide ? "hidden" : ""} `}
      >
         {
            ! isLoading && <div
            className={` mx-auto flex w-[1128px] max-w-[100%] relative justify-between ${
              id === "section9" ? "gap-[67px]" : "gap-[0px]",
              id === "section5" ? "justify-between gap-[64px]" : "",
              id === "section2" ? "justify-between" : "",
              id === "section2" ? "justify-start items-start pt-[120px] laptop:pt-[0] max767:pt-[64px]" : ""
              
            } ${
              id === "section2" || "section5" || "section1"
                ? "ipad:flex-col"
                : "flex"
            } ${id === "section2" || "section6" ? "max767:flex-col" : "flex"}
             ${id === "section1" || "laptop:w-[540px]" ? "laptop:max-w-[100%]" : "flex"} ${
              !isCenterAligned ? "" : "flex-col text-center items-center"
            } ${ id === "section2" ? " pt-0 ":""}`
            
          }
          >
            {isRightAligned && children}
            <div
              className={`${
                !isCenterAligned
                  ? `${ id === "section5" ? "pr-0" : ""} flex-col w-[640px] laptop:w-[526px]  leftone max-w-[100%] pl-0 ipad:w-[100%] ipad:pr-0 max767:pt-0 rtl:pr-0 rtl:pl-16 ${
                      id === "section2" ? "pt-[120px]" : " pt-[0px] ipad:pt-0",
                       id === "section1" ? "w-[630px]" : "",
                         id === "section2" ? "pt-[120px]" : " pt-[0px] ipad:pt-0",
                       id === "section5" ? "content-center pr-6 max767:rtl:pr-0 max767:rtl:pl-0 max767:pt-[64px]" : ""
                       
                    } `
                  : "w-full"
              } ${id === "section1" ? "pt-[0px]" : "pt-[0px]"} ${
                id === "section5" ? "max767:order-2" : ""
              }`}
            >
              {logo && <img src={logo} alt="logo" className="mb-4 max-h-[120px]" />}
              <TitleDescription id={id} title={title} description={description} />
              {playstoreBtns && (
                <div className="flex justify-start gap-4  mt-6">
                  {playstoreBtns}
                </div>
              )}
            </div>
            {isLeftAligned && children}
            {layout === "center" && (
              <div className="mt-4 w-full flex justify-center ">{children}</div>
            )}
          </div>
         }
        
      </div>
    );
  };

export default SectionLayout